import {
  __name
} from "./chunk-DVUTYNGK.jsx";

// src/utils/string/string.ts
var populateStringTemplate = /* @__PURE__ */ __name((str, ...args) => {
  if (!str) return "";
  return str.replace(/{(\d+)}/g, (match, index) => {
    return typeof args[index] !== "undefined" ? args[index] : match;
  });
}, "populateStringTemplate");
var stringIdfy = /* @__PURE__ */ __name((string) => {
  return string == null ? void 0 : string.trim().replace(/[^a-zA-Z0-9]/g, "-").toLowerCase();
}, "stringIdfy");
var truncate = /* @__PURE__ */ __name((string, length) => (string == null ? void 0 : string.length) > length ? `${string.slice(0, length).trim()}...` : string, "truncate");
var toKebabCase = /* @__PURE__ */ __name((string) => {
  var _a, _b;
  return (_b = (_a = string == null ? void 0 : string.replace(/([a-z])([A-Z])/g, "$1-$2")) == null ? void 0 : _a.replace(/\s+/g, "-")) == null ? void 0 : _b.toLowerCase();
}, "toKebabCase");
var toConstantCase = /* @__PURE__ */ __name((str) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = str == null ? void 0 : str.replace(/([a-z])([A-Z])/g, "$1_$2")) == null ? void 0 : _a.replace(/(\d)/g, "_$1_")) == null ? void 0 : _b.replace(/[\s.-]+/g, "_")) == null ? void 0 : _c.toUpperCase();
}, "toConstantCase");
var titleCase = /* @__PURE__ */ __name((str) => {
  if (!str) return "";
  return str.replace("_", " ").replace(/\w\S*/g, (word) => {
    return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
  });
}, "titleCase");
var getFileExtension = /* @__PURE__ */ __name((fileSrc) => fileSrc == null ? void 0 : fileSrc.slice(fileSrc.lastIndexOf(".")), "getFileExtension");

export {
  populateStringTemplate,
  stringIdfy,
  truncate,
  toKebabCase,
  toConstantCase,
  titleCase,
  getFileExtension
};
